import React, { useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { useAuth } from '@/shared/contexts'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const navigate = useNavigate()
  const { user, isLoading } = useAuth()

  useEffect(() => {
    if (!isLoading && !user) {
      console.log('User not authenticated, redirecting to login')
      navigate({ to: '/login' })
    }
  }, [user, isLoading, navigate])

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex items-center space-x-3">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-600"></div>
          <span className="text-gray-600 font-medium">Проверка авторизации...</span>
        </div>
      </div>
    )
  }

  if (!user) {
    return null // Редирект происходит в useEffect
  }

  return <>{children}</>
}
